
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetDictionary } from "@/request/common";
import { GetKey } from "@/utils/base";
@Component({})
export default class Name extends Vue {
  @Prop()
  private title: any; // 标题
  @Prop({ type: String, default: "name" })
  private nameKey: any;
  @Prop({ type: Number, default: -1 })
  private maxNum: any;
  @Prop({ type: Boolean, default: false })
  private ifBlock: any; // 导航选项是否单独一行
  @Prop({ type: Boolean, default: false })
  private hideInput: any; // 是否隐藏自定义输入框
  @Prop({ type: Boolean, default: false })
  private isLevelMore: any; // 是否是二级选择
  @Prop()
  private labelW: any; // 左边分类的宽度
  @Prop()
  private selectVal: any; // 选择的值
  @Watch("selectVal", { immediate: true })
  private selectValChange() {
    if (this.selectVal && this.selectVal.length > 0) {
      this.value = JSON.parse(JSON.stringify(this.selectVal));
    } else {
      this.value = [];
    }
  }
  @Prop()
  private ifShow: any; // 弹框是否显示
  @Watch("ifShow", { immediate: true })
  private ifShowChange() {
    this.visible = this.ifShow;
    this.getData();
  }
  private data: any = [];
  private levelData: any = {
    生活方式: [
      {
        label: "吸烟",
        value: "吸烟",
        children: [],
      },
      {
        label: "现居住地",
        value: "现居住地",
        children: [],
      },
      {
        label: "现居住地区(以长江为界)",
        value: "现居住地区",
        children: [],
      },
      {
        label: "睡眠习惯",
        value: "睡眠习惯",
        children: [],
      },
      {
        label: "饮酒",
        value: "饮酒",
        children: [],
      },
      {
        label: "饮食习惯",
        value: "饮食习惯",
        children: [],
      },
      {
        label: "饮食偏好",
        value: "饮食偏好",
        children: [],
      },
    ],
  };
  private options: any = []; // 根据传入的data处理的打平选项
  private visible: any = true;
  private d: any = [];
  private value: any = [];
  private value2: any = "";
  private delTag(i: any) {
    this.value.splice(i, 1);
  }
  private blur() {
    this.value2 = "";
  }
  private clickSelect() {
    (this.$refs.textInput as any).focus();
  }
  private enter() {
    let text: any = this.value2;
    if (this.value2) {
      text = this.value2.trim();
    }
    if (!text) {
      return;
    }
    let ifExit: any = false;
    this.value.forEach((ele: any) => {
      if (ele.id === this.value2) {
        ifExit = true;
      }
    });
    if (ifExit) {
      this.value2 = "";
    } else {
      if (this.maxNum != -1 && this.value.length > this.maxNum - 1) {
        this.$message.warning("最多只能添加" + this.maxNum + "个");
        return;
      }
      let obj: any = {};
      obj.id = this.value2;
      this.value.push(obj);
      this.value2 = "";
    }
  }
  private cancel() {
    this.$emit("cancel");
  }
  private makeSure() {
    this.$emit("change", this.value);
  }
  // 点击下面的结构选择
  private select(item: any) {
    if (this.ifSelected(item)) {
      // 删除一个
      let index: any;
      this.value.forEach((ele: any, i: any) => {
        if (ele.id === item.id) {
          index = i;
        }
      });
      this.value.splice(index, 1);
    } else {
      //添加一个
      if (this.maxNum != -1 && this.value.length > this.maxNum - 1) {
        this.$message.warning("最多只能添加" + this.maxNum + "个");
        return;
      }
      let obj: any = JSON.parse(JSON.stringify(item));
      obj.id = item.id;
      this.value.push(obj);
    }
  }
  private ifSelected(val: any) {
    let result: any = false;
    this.value.forEach((ele: any) => {
      if (ele.id === val.id) {
        result = true;
      }
    });
    return result;
  }
  private getData() {
    if (this.isLevelMore) {
      this.levelData[this.title].forEach((ele: any) => {
        const params: any = {
          params: {
            dictionary_key: ele.value,
          },
        };
        ele.children = [];
        GetDictionary(this, params).then((res: any) => {
          ele.children = res.data;
        });
      });
    } else {
      const params: any = {
        params: {
          dictionary_key: this.title,
        },
      };
      GetDictionary(this, params).then((res: any) => {
        this.data = res.data;
      });
    }
  }
}
